import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginPageComponent} from './common/login-page/login-page.component';
import {AuthGuardService} from './auth/auth-guard.service';
import {ResourceResolveService} from './common/resource-resolve.service';

const routes: Routes = [
    {
        path: '',
        canActivate: [AuthGuardService],
        canActivateChild: [AuthGuardService],
        resolve: {cache: ResourceResolveService},
        children: [
            {path: '', redirectTo: 'apply', pathMatch: 'full'},
            {path: 'apply', loadChildren: () => import('./app-form/app-form.module').then(m => m.AppFormModule)},
            {path: 'result', loadChildren: () => import('./app-result/app-result.module').then(m => m.AppResultModule)},
        ]
    },
    {path: 'login', component: LoginPageComponent},
    {path: 'login/:token', component: LoginPageComponent},
    {path: 'login-mos', component: LoginPageComponent},
    {path: 'login-klnt', component: LoginPageComponent},
    {path: 'login-mos/:token', component: LoginPageComponent},
    {path: 'login-klnt/:token', component: LoginPageComponent},
    {path: 'mos', redirectTo: 'login-mos'},
    {path: 'klnt', redirectTo: 'login-klnt'},
    {path: '**', redirectTo: 'login'},
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {enableTracing: false})],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
